import { CheckCircle2, Clock, AlertTriangle, CircleDot, Archive, XCircle, FileText, TimerReset } from "lucide-react";

// Status visual config — NEVER color alone: dot/icon + text.
export const STATUS_STYLES = {
  "Paid": { cls: "bg-[#F0F5F1] text-[#2D593E] border-[#CBE0D2]", Icon: CheckCircle2 },
  "Received": { cls: "bg-[#F0F5F1] text-[#2D593E] border-[#CBE0D2]", Icon: CheckCircle2 },
  "Upcoming": { cls: "bg-[#F4F0EA] text-[#635B54] border-[#E5DDD3]", Icon: Clock },
  "Due Today": { cls: "bg-[#FDF0EA] text-[#C85A32] border-[#F8D4C5]", Icon: TimerReset },
  "Overdue": { cls: "bg-[#FDF0F0] text-[#B93826] border-[#F9C8C3]", Icon: AlertTriangle },
  "Pending": { cls: "bg-[#F2F5EF] text-[#5C6B47] border-[#D9E2D0]", Icon: CircleDot },
  "Processing": { cls: "bg-[#F2F5EF] text-[#5C6B47] border-[#D9E2D0]", Icon: CircleDot },
  "Expected Today": { cls: "bg-[#FDF0EA] text-[#C85A32] border-[#F8D4C5]", Icon: TimerReset },
  "Expected payout missed": { cls: "bg-[#FDF0F0] text-[#B93826] border-[#F9C8C3]", Icon: AlertTriangle },
  "Draft": { cls: "bg-[#F4F0EA] text-[#635B54] border-[#E5DDD3]", Icon: FileText },
  "Cancelled": { cls: "bg-[#F4F0EA] text-[#968E85] border-[#E5DDD3]", Icon: XCircle },
  "Archived": { cls: "bg-[#F4F0EA] text-[#968E85] border-[#E5DDD3]", Icon: Archive },
};

// Human-readable descriptions for account events (Notification Center + Activity).
export const EVENT_LABELS = {
  invoice_created: "Invoice created",
  invoice_sent: "Invoice marked sent",
  invoice_due_today: "Invoice is due today",
  invoice_became_overdue: "Invoice became overdue",
  invoice_marked_paid: "Invoice marked paid",
  invoice_cancelled: "Invoice cancelled",
  invoice_archived: "Invoice archived",
  invoice_due_date_changed: "Invoice due date changed",
  payout_created: "Payout scheduled",
  payout_processing: "Payout marked processing",
  payout_expected_today: "Payout expected today",
  payout_expected_date_passed: "Expected payout missed",
  payout_marked_paid: "Payout marked received",
  payout_cancelled: "Payout cancelled",
  payout_archived: "Payout archived",
  payout_expected_date_changed: "Payout expected date changed",
  sms_opt_in_requested: "SMS opt-in requested",
  sms_subscribed: "Subscribed to SMS alerts",
  sms_unsubscribed: "Unsubscribed from SMS alerts",
  invoice_recurring_spawned: "Recurring invoice created",
  invoice_snoozed: "Invoice snoozed",
  invoice_snooze_reminder: "Snoozed invoice reminder",
  weekly_digest: "Weekly summary",
};

export const TIMEZONES = [
  "America/New_York", "America/Chicago", "America/Denver", "America/Los_Angeles",
  "America/Toronto", "America/Sao_Paulo", "Europe/London", "Europe/Paris",
  "Europe/Berlin", "Asia/Kolkata", "Asia/Singapore", "Asia/Tokyo",
  "Australia/Sydney", "UTC",
];

export const CURRENCIES = ["USD", "EUR", "GBP", "INR", "CAD", "AUD"];

export const FILTERS = [
  { key: "all", label: "All" },
  { key: "invoices", label: "Invoices" },
  { key: "payouts", label: "Payouts" },
  { key: "upcoming", label: "Upcoming" },
  { key: "due", label: "Due Today" },
  { key: "overdue", label: "Overdue / Missed" },
  { key: "paid", label: "Paid" },
];

export const SORTS = [
  { key: "date", label: "Due / expected date" },
  { key: "amount", label: "Amount" },
  { key: "newest", label: "Newest" },
  { key: "oldest", label: "Oldest" },
  { key: "status", label: "Status" },
];

export const CONSENT_TEXT =
  "By checking this box, you agree to receive automated account notifications about activity and information in your account from PaySignal at the mobile number provided. Message frequency varies. Msg & data rates may apply. Reply STOP to opt out, HELP for help. See our SMS Terms and Privacy Policy. Consent is not a condition of using PaySignal.";

// Exact wording shown at signup/settings. Keep in sync with backend auth.py CONSENT_KINDS.
export const SMS_TRANSACTIONAL_CONSENT_TEXT =
  "I give my express consent to receive recurring automated payment alerts and account notifications texts to the phone number from paysignal.ai. Message frequency varies according to account settings. Msg & data rates may apply. I understand I can opt-out by replying 'STOP' to any message, or get more info by replying 'HELP.' Consent is not required for purchasing products or services. My number will not be shared with third parties or affiliates.";
export const SMS_PROMO_CONSENT_TEXT =
  "I give my express express consent to receive occasional promotional marketing messages to the phone number from paysignal.ai. Message frequency varies. Msg & data rates may apply. I understand I can opt-out by replying 'STOP' to any message, or get more info by replying 'HELP.' Consent is not required for purchasing products or services. My number will not be shared with third parties or affiliates.";
export const SMS_SIGNUP_CONSENT_VERSION = "sms_transactional_v5_en-US";
export const SMS_PROMO_CONSENT_VERSION = "sms_promotional_v1_en-US";

export const COUNTRIES = [
  { code: "US", name: "United States" },
  { code: "CA", name: "Canada" },
];

export const US_STATES = [
  "Alabama","Alaska","Arizona","Arkansas","California","Colorado","Connecticut","Delaware",
  "District of Columbia","Florida","Georgia","Hawaii","Idaho","Illinois","Indiana","Iowa",
  "Kansas","Kentucky","Louisiana","Maine","Maryland","Massachusetts","Michigan","Minnesota",
  "Mississippi","Missouri","Montana","Nebraska","Nevada","New Hampshire","New Jersey","New Mexico",
  "New York","North Carolina","North Dakota","Ohio","Oklahoma","Oregon","Pennsylvania","Puerto Rico",
  "Rhode Island","South Carolina","South Dakota","Tennessee","Texas","Utah","Vermont","Virginia",
  "Washington","West Virginia","Wisconsin","Wyoming",
];

export const CA_PROVINCES = [
  "Alberta","British Columbia","Manitoba","New Brunswick","Newfoundland and Labrador",
  "Northwest Territories","Nova Scotia","Nunavut","Ontario","Prince Edward Island",
  "Quebec","Saskatchewan","Yukon",
];

export const STATES_BY_COUNTRY = { US: US_STATES, CA: CA_PROVINCES };
